import Validator from 'validator';
import isEmpty from 'is-empty';
import { regexPassword, regexUsername } from '../constants';

export function validateChangePassword(data) {
  let errors = {};

  if (data.oldPassword === null || Validator.isEmpty(data.oldPassword)) {
    errors.oldPassword = 'Old password is required';
  }

  const passwordValidationResult = validatePassword(data.newPassword);

  if (!passwordValidationResult.valid) {
    errors.newPassword = passwordValidationResult.message;
  }

  if (
    data.newPassword !== null &&
    !Validator.isEmpty(data.newPassword) &&
    data.oldPassword === data.newPassword
  ) {
    errors.newPassword = 'New password cannot be the same as your current password.';
  }

  if (data.repeatPassword === null || Validator.isEmpty(data.repeatPassword)) {
    errors.repeatPassword = 'Repeat password is required';
  } else if (!Validator.equals(data.newPassword, data.repeatPassword)) {
    errors.repeatPassword = 'Passwords must match';
  }

  return {
    errors,
    valid: isEmpty(errors),
  };
}

export function validatePassword(password) {
  let message = null;

  if (password === null || Validator.isEmpty(password)) {
    message = 'New password is required';
  } else if (!regexPassword.test(password)) {
    message =
      'Complexity criteria not met (It must contain at least 7 characters, one small letter, one big letter, one character and one number)';
  }

  return {
    message,
    valid: message ? false : true,
  };
}

const USERNAME_CRITERIA =
  'Username must be 7–20 characters long, contain at least one uppercase letter and one lowercase letter, and can only contain letters, numbers, underscores, hyphens, or dots. It cannot start or end with a special character, and cannot have consecutive special characters.';

export function validateUsername(username) {
  let message = null;

  if (username === null || Validator.isEmpty(username)) {
    message = 'Username is required';
  } else {
    const regexUsername = /^[a-zA-Z0-9]([._-](?![._-])|[a-zA-Z0-9]){5,18}[a-zA-Z0-9]$/;
    const valid =
      !username.includes(' ') &&
      username.length >= 7 &&
      username.length <= 20 &&
      /[A-Z]/.test(username) &&
      /[a-z]/.test(username) &&
      regexUsername.test(username);

    if (!valid) {
      message = USERNAME_CRITERIA;
    }
  }

  return {
    message,
    valid: message ? false : true,
  };
}
